import { Tree } from 'antd';
import styled from 'styled-components';

import { CSS_PREFIX } from '@/constants/styles';
import { GreenColors, NeutralColors } from '@/theme';

export const RegionTree = styled(Tree)`
  max-height: 360px;
  overflow-y: auto;

  .${CSS_PREFIX}-tree-treenode {
    width: 100%;
    min-height: 40px;
    align-items: center;
  }

  .${CSS_PREFIX}-tree-node-content-wrapper {
    flex: 1;
  }

  .${CSS_PREFIX}-tree-switcher {
    display: none;
  }
`;

export const RegionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

export const RegionIcon = styled.span`
  display: flex;
  width: 18px;
  height: 18px;
  padding: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${GreenColors[10]};
  color: ${GreenColors[60]};
`;

export const CurrentRegion = styled.span`
  padding: 0 8px;
  border-radius: 24px;
  background: ${GreenColors[10]};
  color: ${GreenColors[70]};
  font-size: 16px;
  font-weight: 600;
  font-size: 14px;
`;

export const NoResults = styled.div`
  color: ${NeutralColors[60]};
  text-align: center;
`;
